var React = require('react');

function Warning (props) {
    return React.createElement("svg",props,React.createElement("path",{"d":"M0,14.9h16L8,1.1L0,14.9z M8.7,12.7H7.3v-1.5h1.5V12.7z M8.7,9.8H7.3V6.9h1.5V9.8z","fill":"currentColor"}));
}

Warning.defaultProps = {"version":"1.1","id":"Layer_1","x":"0px","y":"0px","viewBox":"0 0 16 16","style":{"enableBackground":"new 0 0 16 16"},"xmlSpace":"preserve"};

module.exports = Warning;

Warning.default = Warning;
